module.exports = __webpack_public_path__ + "img/Kostanay.35f81a43.png";